import {
  FormGroup,
  InputGroup,
} from "@blueprintjs/core";
import {
  MDBCol,
} from "mdbreact";
import { observer } from "mobx-react";
import * as React from "react";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import PhoneInput from 'react-phone-input-2';

@observer
export default class EmpresaCalculos extends React.Component<{}, {}> {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <MDBCol>

          <div style={{ width: 1000 }}>

            <FormGroup
              label="E-mail Erros de Cálculo"
              labelFor="senha"
              style={{ width: "49%" }}
            >
              <InputGroup
                autoComplete="email-calculos"
                name="email-calculos"
                id="nome-fantasia-off"
                placeholder="email@email.com"
                value={EmpresaStore.obs.empresa_edit.email_calculos}
                onChange={(e: any) => EmpresaStore.obs.empresa_edit.email_calculos = e.target.value}
              />
            </FormGroup>

          </div>

          <div style={{ width: 1000 }}>

            <FormGroup
              label="E-mail Alerta notas com valor acima de 1 milhão"
              labelFor="senha"
              style={{ width: "49%" }}
            >
              <InputGroup
                autoComplete="email-alerta"
                name="email-alerta"
                id="nome-fantasia-off"
                placeholder="email@email.com"
                value={EmpresaStore.obs.empresa_edit.email_alerta}
                onChange={(e: any) => EmpresaStore.obs.empresa_edit.email_alerta = e.target.value}
              />
            </FormGroup>

          </div>

          <div style={{ width: 400 }}>

          <FormGroup 
            label="Whatsapp Alerta notas com valor acima de 1 milhão"
            helperText="Insira um número com DDD para receber as cópias dos arquivos."
          >
                <PhoneInput
                  country={'br'}
                  enableSearch
                  excludeCountries={['us','ua','ru']}
                  value={EmpresaStore.obs.empresa_edit.numero_alerta}
                  onChange={phone => EmpresaStore.obs.empresa_edit.numero_alerta = phone }
                  inputClass="phone-input"
                  searchClass="phone-input-search"
                  disableSearchIcon
                />
 
              </FormGroup>

          </div>

        </MDBCol>

      </>
    );
  }
}
